import {
  Component,
  DestroyRef,
  HostListener,
  signal,
  WritableSignal,
} from '@angular/core';
import { ModuleConst, sideBar } from '../../core/constants/sidebar.const';
import { assets } from '../../core/constants/assets.const';
import { AuthService } from '../../core/services/auth.service';
import { sidebarInterface } from '../../models/sideBar.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, map, tap } from 'rxjs';

const removableItems = new Set([ModuleConst.SubAdmin]);
@Component({
  selector: 'real-estate-admin-sidebar',
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent {
  readonly assetsConst = assets;
  readonly sideBar: WritableSignal<sidebarInterface[]> = signal(sideBar);
  private innerWidth = 0;

  constructor(
    private _authService: AuthService,
    private destroyRef: DestroyRef
  ) {
    this._authService.profileDetails
      .pipe(
        filter(Boolean),
        takeUntilDestroyed(this.destroyRef),
        map(res => {
          if (res?.exclusive?.length) {
            return res.exclusive
              .map(el => {
                const tab = sideBar.find(i => i.sideBarId === el.sideBarId);

                return tab
                  ? {
                      ...tab,
                      isAdd: true,
                      isDelete: true,
                      isEdit: true,
                      isView: true,
                    }
                  : null;
              })
              .filter(i => i !== null) as sidebarInterface[];
          }

          const items = sideBar.map(i => i.sideBarId);
          return sideBar
            .filter(el => !removableItems.has(el.sideBarId))
            .map(el => {
              const current = res.permission?.find(el =>
                items.includes(el.sideBarId)
              );

              return current
                ? {
                    ...current,
                  }
                : {
                    ...el,
                    isAdd: true,
                    isDelete: true,
                    isEdit: true,
                    isView: true,
                  };
            });
        }),

        tap(bar => this.sideBar.set(bar))
      )
      .subscribe();
  }

  @HostListener('window', ['$event'])
  toggleSidenav(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 991) {
      this._authService.toggleSidebarView();
    }
  }
}
